export default {
  doubt: null,
  orderDetails: [],
  orderDetail: null,
  boughtBrands: [],
}
